export class TagMatchType {
    canEdit?: boolean;
    canMatch?: boolean;
    createUserId?: number;
    isMatched?: boolean;
    tagId: number;
    tagName: string;
    tagTypeId: number;
    tagTypeName: string;
}
